import { Pipe, PipeTransform } from '@angular/core';
import { Address } from '@jms/model';

@Pipe({
  name: 'street',
  standalone: true
})
export class StreetPipe implements PipeTransform {

  transform(address: Address, ...args: unknown[]): string {

    return address ? (address.street1 ? `${address.street1}` : `${address.street2}`) : ``;
  }

}
